import { render, staticRenderFns } from "./GeolocationMessage.vue?vue&type=template&id=2defb35e&scoped=true&"
import script from "./GeolocationMessage.vue?vue&type=script&lang=js&"
export * from "./GeolocationMessage.vue?vue&type=script&lang=js&"
import style0 from "./GeolocationMessage.vue?vue&type=style&index=0&id=2defb35e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2defb35e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
